import React from "react";
import { Icon } from "@iconify/react";
import { Typography } from "../Typography";

const Dialog = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  maxWidth = "max-w-md",
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className={`w-full ${maxWidth} bg-white rounded-2xl shadow-xl max-h-[90vh] overflow-hidden flex flex-col`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        {(title || description) && (
          <div className="flex items-start justify-between p-6 border-b border-slate-200">
            <div className="flex flex-col gap-1 flex-1">
              {title && (
                <Typography as="h2" className="text-xl font-bold text-primary-900">
                  {title}
                </Typography>
              )}
              {description && (
                <Typography as="p" className="text-sm text-tertiary-600">
                  {description}
                </Typography>
              )}
            </div>
            <button
              onClick={onClose}
              className="text-slate-400 hover:text-slate-600 transition-colors ml-4"
            >
              <Icon icon="lucide:x" className="h-5 w-5" />
            </button>
          </div>
        )}
        {!title && !description && (
          <div className="flex items-center justify-end p-4">
            <button
              onClick={onClose}
              className="text-slate-400 hover:text-slate-600 transition-colors"
            >
              <Icon icon="lucide:x" className="h-5 w-5" />
            </button>
          </div>
        )}

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">{children}</div>
      </div>
    </div>
  );
};

export default Dialog;

